import axios from "axios";

function checkResponse(res) {
  if (typeof response === "string") {
    console.log(JSON.parse(res));
    return res;
  }

  switch (res.status) {
    case 400:
      return res.json();
    case 404:
      return res.json();
    case 500:
    case 503:
      console.log(res.json())
     return {result: false ,msg: '伺服器出現問題 請稍後再試', status: res.status}
      
    default:
      break;
  }

  return res.json();
}

export default function httpClientService(method, url, authToken, data) {
  // eslint-disable-next-line default-case
  // const cors = 'https://cors-anywhere.herokuapp.com/'; // use cors-anywhere to fetch api data

  switch (method) {
    case "get": {
      return fetch(`${url}`, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }),
      }).then((response) => {
        console.log("response = ", response);
        // if (typeof response === "string") {
        //   console.log(JSON.parse(response));
        //   return JSON.parse(response);
        // }
        // // 直接轉成JSON格式
        // return response.json();
        return checkResponse(response);
      });
    }

    case "post": {
      return fetch(`${url}`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }),
        // mode: 'no-cors',
        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log("response = ", response);
          // 直接轉成JSON格式
          return response.json();
        })
        .catch((error) => {
          return error;
        });
    }

    case "delete": {
      return fetch(`${url}`, {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }),
      })
        .then((response) => {
          // console.log('response = ', response.json());
          // 直接轉成JSON格式
          return response.json();
        })
        .catch((error) => {
          return error;
        });
    }

    case "put": {
      return axios.put(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        data,
      });
    }

    case "patch": {
      return axios.patch(url, data);
    }

    default:
      // console.log(`Unknown method: ${method}`);
      return false;
  }
}
